import { useParams } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { parseLinkToken } from '@/lib/link'
import { loadRuntimeConfig, type RuntimeConfig } from '@/lib/runtime-config'
import { ReportAccessFlow } from '@/report/report-access-flow'
import { CenteredMessage } from '@/report/screens'
import { copy } from '@/report/copy'
import { NotFoundPage } from './not-found-page'

type ConfigState = { status: 'loading' } | { status: 'ready'; config: RuntimeConfig } | { status: 'failed' }

export function ReportLinkPage() {
  const { linkToken } = useParams({ from: '/$linkToken' })
  const credential = parseLinkToken(linkToken)

  if (credential === null) {
    return <NotFoundPage />
  }

  return <ConfiguredReportAccess linkToken={credential} />
}

function ConfiguredReportAccess({ linkToken }: { linkToken: string }) {
  const [state, setState] = useState<ConfigState>({ status: 'loading' })

  useEffect(() => {
    let cancelled = false
    loadRuntimeConfig().then(
      (config) => !cancelled && setState({ status: 'ready', config }),
      () => !cancelled && setState({ status: 'failed' }),
    )
    return () => {
      cancelled = true
    }
  }, [])

  if (state.status === 'loading') return <CenteredMessage>{copy.access.loading}</CenteredMessage>
  if (state.status === 'failed') return <CenteredMessage alert>{copy.access.unreachable}</CenteredMessage>
  return <ReportAccessFlow config={state.config} linkToken={linkToken} />
}
